import { Formik } from "formik";

import {
    Button,
    Grid,
  } from "@mui/material";

import { useNavigate } from "react-router-dom";


const RegisterSuccess = () =>{
    const navigate = useNavigate();

    return (
        <>
            <Formik
            initialValues={{
                submit: null,
            }}
            onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                setStatus({ success: false });
                setSubmitting(false);
                
                navigate('/login');
            }}
        >
            {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
            }) => (
                <form noValidate onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Button
                                disableElevation
                                fullWidth
                                size="large"
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                Back to login
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            )}
        </Formik>
    </>
    );
}

export default RegisterSuccess;